"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7008],{

/***/ 78721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Code; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/solutions/simple-header.tsx
var simple_header = __webpack_require__(72438);
// EXTERNAL MODULE: ./components/sanity/serializers/code.tsx + 1 modules
var code = __webpack_require__(10814);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./components/solutions/simple-sign-in.tsx





const SimpleSignIn = (props)=>{
    let { imagePosition  } = props;
    const { signIn  } = props;
    if (!imagePosition) {
        imagePosition = "right";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("max-w-xl px-4 mx-auto sm:px-6 lg:max-w-none lg:mx-0 lg:px-0", imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                    children: "<SignIn />"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 text-gray-500 text",
                                    children: "Your sign-in flow is the only thing sitting between existing users and your application—it's absolutely critical that users can complete the process quickly."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
                                    language: "jsx",
                                    theme: "dark",
                                    highlightedLines: undefined,
                                    children: signIn
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("flex justify-center items-center px-8 max-w-xl mx-auto", imagePosition === "right" ? "lg:col-start-2" : "lg:col-start-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "object-cover w-full",
                        src: "/images/components/sign-in-full.svg",
                        alt: "sign-in-full",
                        width: 496,
                        height: 334
                    })
                })
            ]
        })
    });
};
SimpleSignIn.defaultProps = {
    imagePosition: undefined
};
/* harmony default export */ var simple_sign_in = (SimpleSignIn);

;// CONCATENATED MODULE: ./components/solutions/simple-user-profile.tsx





const SimpleUserProfile = (props)=>{
    let { imagePosition  } = props;
    const { userProfile  } = props;
    if (!imagePosition) {
        imagePosition = "right";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-8 lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("max-w-xl px-4 mx-auto sm:px-6 lg:max-w-none lg:mx-0 lg:px-0", imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                    children: "<UserProfile />"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 text-gray-500 text",
                                    children: "A place for your users to change their password, turn on multifactor auth, revoke bad sessions, and more. Every app should offer the best security options, so every user can be safe."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
                                    language: "jsx",
                                    theme: "dark",
                                    highlightedLines: undefined,
                                    children: userProfile
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("flex justify-center items-center px-8 max-w-xl mx-auto", imagePosition === "right" ? "lg:col-start-2" : "lg:col-start-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "object-cover w-full ",
                        src: "/images/components/user-profile-full.svg",
                        alt: "user-profile-full",
                        width: 496,
                        height: 334
                    })
                })
            ]
        })
    });
};
SimpleUserProfile.defaultProps = {
    imagePosition: undefined
};
/* harmony default export */ var simple_user_profile = (SimpleUserProfile);

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowSmRightIcon.js
var ArrowSmRightIcon = __webpack_require__(79526);
;// CONCATENATED MODULE: ./components/solutions/code.tsx





function Code(param) {
    let { signIn , userProfile  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mt-28",
        id: "simple",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_sign_in, {
                        imagePosition: "right",
                        signIn: signIn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_user_profile, {
                        imagePosition: "right",
                        userProfile: userProfile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-8 rounded-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "/docs/component-reference/overview",
                                target: "_blank",
                                className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn",
                                rel: "noopener",
                                children: [
                                    "See all components",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowSmRightIcon/* default */.Z, {
                                        className: "w-6 h-6 ml-1 -mr-1.5"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 83976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ GetStarted; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowSmRightIcon.js
var ArrowSmRightIcon = __webpack_require__(79526);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/solutions/doc-link.tsx


function DocLink(param) {
    let { doc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-1 my-2 rounded-md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: doc,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "flex items-center justify-center px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-clerk-blue md:w-full hover:bg-gray-50 md:py-4 md:text-lg md:px-10 btn btn-outline",
                children: "Explore the docs"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/solutions/get-started.tsx



function GetStarted(param) {
    let { doc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "mt-10 mb-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full px-4 mx-auto mt-5 sm:px-0 sm:flex-row sm:flex sm:justify-center md:mt-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DocLink, {
                    doc: doc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-2 rounded-md sm:mx-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat("https://dashboard.clerkstage.dev", "/sign-up"),
                        className: "flex items-center justify-center px-8 py-3 text-base font-medium text-white border border-transparent rounded-md md:w-full bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn",
                        children: [
                            "Start building now",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowSmRightIcon/* default */.Z, {
                                className: "w-6 h-6 ml-1 -mr-1.5"
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 41662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Header(param) {
    let { title , boldTitle , subheader  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-y-0 w-full h-full",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative h-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative pt-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 mx-auto max-w-7xl sm:px-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block text-clerk-blue",
                                        children: boldTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                                dangerouslySetInnerHTML: {
                                    __html: subheader
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 94073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Powerful; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64343);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8639);



const features = [
    {
        name: "Magic links",
        description: "Make passwords obsolete by sending your users magic links"
    },
    {
        name: "Session management",
        description: " Revocable and stateless, the best of both worlds."
    },
    {
        name: "Multifactor authentication",
        description: "Secure your users with multiple steps during sign in."
    },
    {
        name: "Social sign-in",
        description: "Let your users sign in with Google, Facebook, and more"
    },
    {
        name: "Multi-session management",
        description: "Allow your users to sign in to multiple accounts at once."
    },
    {
        name: "New device notifications",
        description: "Proactively notify users when a new device signs in.  Let's your users protect themself."
    },
    {
        name: "Password leak protection",
        description: "Proactively protects your users against passwords that appear in leaks."
    },
    {
        name: "Advanced security",
        description: "Clerk detects and blocks phishy sign ins out of the box."
    }
];
function Powerful() {
    const featuresData = features;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                                children: "Immensely Powerful."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "max-w-xl mx-auto mt-2 text-xl text-gray-500",
                                children: [
                                    "The features your users ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: "expect"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                        className: "mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8",
                        children: featuresData.map((feature)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dt", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                className: "absolute w-6 h-6 text-green-500",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-lg font-medium leading-6 text-gray-900 ml-9",
                                                children: feature.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                        className: "mt-2 text-base text-gray-500 ml-9",
                                        children: feature.description
                                    })
                                ]
                            }, feature.name))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-md mx-auto mt-16 sm:flex sm:justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 rounded-md",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "".concat("https://dashboard.clerkstage.dev", "/sign-up"),
                            target: "_blank",
                            className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn",
                            rel: "noopener",
                            children: [
                                "Start building now",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "w-6 h-6 ml-1 -mr-1.5"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 72438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SimpleHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const SimpleHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                            children: "Radically Simple."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "max-w-xl mx-auto mt-2 text-xl text-gray-500",
                            children: [
                                "It only takes ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "one line"
                                }),
                                " of code."
                            ]
                        })
                    ]
                })
            })
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (SimpleHeader);


/***/ }),

/***/ 49596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SmallQuote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27013);


function SmallQuote(param) {
    let { quote , image , name , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-4 py-10 sm:px-8 lg:px-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
            className: "max-w-3xl mx-auto font-medium",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-lg text-center sm:text-xl md:leading-9 md:text-2xl",
                    children: [
                        "“",
                        quote,
                        "”"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-row items-center justify-center mt-4 md:mt-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-10 h-10 mr-4 overflow-hidden rounded-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .SaneImage */ .Q, {
                                src: image
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "md:flex md:items-center md:justify-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-900",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "hidden w-5 h-5 mx-1 text-indigo-600 md:block",
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M11 0h3L9 20H6l5-20z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-500",
                                    children: title
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 8639:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ArrowSmRightIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 7l5 5m0 0l-5 5m5-5H6"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ArrowSmRightIcon);

/***/ }),

/***/ 64343:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CheckIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 13l4 4L19 7"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CheckIcon);

/***/ }),

/***/ 79526:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ArrowSmRightIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ArrowSmRightIcon);

/***/ })

}]);